module.exports = __webpack_public_path__ + "files/4c418b1cff2574b619f920c1c101d9d6.png";